import React from 'react'

const AllocateEarthingTesting = () => {
  return (
    <div>
      AllocateEarthingTesting
    </div>
  )
}

export default AllocateEarthingTesting
